import React from "react";
import Layout from "../../components/shared/Layout/Layout";
import ClassworkPerformanceViewResults from "../../components/ClassworkPerformanceViewResults/ClassworkPerformanceViewResults";

const ViewClassworkPerformancePage = () => {
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title={`View Classwork Performance`}>
        <ClassworkPerformanceViewResults />
      </Layout>
    </div>
  );
};

export default ViewClassworkPerformancePage;
